import { render, staticRenderFns } from "./ModalMovie.vue?vue&type=template&id=5b425145&"
import script from "./ModalMovie.vue?vue&type=script&lang=js&"
export * from "./ModalMovie.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ModalMovie.vue"
export default component.exports